"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KeyFeatures() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.75
  });
  const features = [{
    icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/live_streaming_icon.png",
    title: "Real-Time Streaming",
    description: "Watch live tournament and action matches in high-definition with seamless streaming powered by WPStream."
  }, {
    icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/interactive_chat_icon.png",
    title: "Interactive Chat",
    description: "Engage with the community during live matches through real-time chat functionality."
  }, {
    icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/video_archive_icon.png",
    title: "On-Demand Archive",
    description: "Access an extensive library of past matches and highlights whenever you want."
  }];
  return <section ref={sectionRef} className="relative overflow-hidden bg-background py-20 px-6 md:px-12 lg:px-20">
      {}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: "linear-gradient(hsl(215, 5%, 40%) 1px, transparent 1px), linear-gradient(90deg, hsl(215, 5%, 40%) 1px, transparent 1px)",
      backgroundSize: "40px 40px"
    }} />

      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {features.map((feature, i) => <div key={i} data-index={i} className={`group relative flex flex-col items-center rounded-lg border border-border bg-surface/60 p-8 text-center shadow-soft backdrop-blur-sm transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:border-primary hover:shadow-[0_0_16px_hsla(4,95%,52%,0.4)] ${isVisible ? "animate-fade-in-up" : "opacity-0 translate-y-4"}`} style={{
          animationDelay: isVisible ? `${i * 100}ms` : "0ms",
          animationFillMode: "forwards"
        }}>
              {}
              <div className="mb-6 animate-pulse">
                <img src={feature.icon} alt="" className="h-16 w-16 object-contain" />
              </div>

              {}
              <h3 className="mb-4 font-display text-xl font-semibold text-foreground">
                {feature.title}
              </h3>

              {}
              <p className="text-sm leading-relaxed text-muted-foreground">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}